export enum DateFilterEnum {
  LAST_MAJ='LAST_MAJ',
  PUBLICATION_DATE="PUBLICATION_DATE"
}
